import React from 'react'
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
const ProductDetails = (props) => {
  function handleDescription(data) {
    props.setProductDescription(data);
    var array = [...props.variations]
    console.log("before", array)
    array.forEach((element, i) => {
      let variationToUpdate = array[i];
      delete array[i];
      variationToUpdate["Description"] = data;
      array[i] = variationToUpdate;
    });
    props.setVariations(array);




  }

  return (
    <>
      <div className="col-lg-12">
        <label>
          Product Name <span className="required">*</span>
        </label>
        <input
          className="form-control"
          id="txtProductName"
          onChange={(e) => props.setProductName(e.target.value)}
          value={props.productName}
        />
      </div>

      <div className="col-lg-12">
        <label>
          Product Name (Arabic) <span className="required">*</span>
        </label>
        <input
          className="form-control"
          id="txtProductNameAR"
          onChange={(e) => props.setProductNameAR(e.target.value)}
          value={props.productNameAR}
        />
      </div>
      <div className="col-lg-12 mt-3">
        <label>Description</label>
        <CKEditor
          editor={ClassicEditor}
          data={props.productDescription}
          value={props.productDescription}
          onChange={(event, editor) => {
            const data = editor.getData();

            handleDescription(data);
          }}
        />
      </div>
      <div className="col-lg-12 mt-3">
        <label>Description (Arabic)</label>
        <CKEditor
          editor={ClassicEditor}
          data={props.productDescriptionAR}
          onChange={(event, editor) => {
            const data = editor.getData();
            props.setProductDescriptionAR(data);
          }}
        />
      </div>
      <div className="col-lg-12 mt-3">
        <label>Small Description</label>
        <CKEditor
          editor={ClassicEditor}
          data={props.smallDescription}
          value={props.smallDescription}
          onChange={(event, editor) => {
            const data = editor.getData();
            props.setSmallDescription(data);
          }}
        />
      </div>
      <div className="col-lg-12 mt-3">
        <label>Small Description (Arabic)</label>
        <CKEditor
          editor={ClassicEditor}
          data={props.smallDescriptionAR}
          onChange={(event, editor) => {
            const data = editor.getData();
            props.setSmallDescriptionAR(data);
          }}
        />
      </div>
      <div className='col-lg-12 mt-3'>
        <div className='d-flex item-center'>
          <label>Product Order</label>
          <input className='form-control ml-5' type='number' placeholder='Enter Product Number'
            id="txtProductOrder"
            onChange={(e) => props.setProductOrder(e.target.value)}
            value={props.productOrder} />
        </div>
      </div>
    </>
  )
}

export default ProductDetails